import React, { useState } from 'react';
import './CalculatorPage.css';

function HealthNumberCalculator() {
  const [dob, setDob] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const calculate = (dateString) => {
    // Placeholder for Health Number calculation logic
    // This is a simplified example, typically involves Life Path or Destiny Number
    const digitsOnly = dateString.replace(/\D/g, '');

    if (digitsOnly.length !== 8) {
      return null; // Invalid length
    }

    const day = parseInt(digitsOnly.substring(0, 2), 10);
    const month = parseInt(digitsOnly.substring(2, 4), 10);
    const year = parseInt(digitsOnly.substring(4, 8), 10);

    if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900 || year > 2100) {
      return null; // Invalid date components
    }

    let sum = 0;
    for (let i = 0; i < digitsOnly.length; i++) {
      sum += parseInt(digitsOnly[i], 10);
    }

    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return sum;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(dob)) {
      setError('Please enter a valid date in DD/MM/YYYY format.');
      return;
    }

    const calculated = calculate(dob);
    if (calculated === null) {
      setError('Invalid date. Please check your input.');
    } else {
      setResult(calculated);
    }
  };

  const getExplanation = (num) => {
    return `Health Number ${num}: This is a placeholder explanation for health number ${num}.`;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Health Number Calculator",
    "description": "Calculate your Health Number based on your birth date and understand its implications for well-being.",
    "url": "https://www.yourwebsite.com/health-number-calculator",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Calculate Health Number",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/health-number-calculator?dob={dob}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=dob"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Health Number Calculator</h1>
      <p className="text-center">Enter your Date of Birth to discover your Health Number.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="dob">Date of Birth (DD/MM/YYYY):</label>
          <input
            type="text"
            id="dob"
            className="form-control"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            placeholder="e.g., 01/01/1990"
            maxLength="10"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Calculate Health Number</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Your Health Number is: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">{getExplanation(result)}</p>
        </div>
      )}
    </div>
  );
}

export default HealthNumberCalculator;
